<div class="documents-actions">
  <div class="Flexbox__box-direction-column">

    <!-- Editing action toggle -->
    <div *ngIf='!completed && editingIsPermitted && showEditDocumentsButton && enableEditButton'
         class="actions-section Flexbox Flexbox__align-self-center dynamic-form-items">
      <label class="edit-label">Edit documents</label>
      <gen-toggle-switch [disabled]="false"
                         (click)="$event.stopPropagation()"
                         (statusUpdate)="onEditing($event)"
                         [active]="this.toggleAction">
      </gen-toggle-switch>
    </div>

    <!-- This is common menu for generation documents, will contains options for all documents -->
    <!--<div *ngIf='!completed && showReleaseDocumentsMenu' class="actions-section" style="margin-top:1rem;">-->
      <!--<gen-common-options-button class="actions-options-button"-->
                                 <!--[buttonText]="'Generate documents'"-->
                                 <!--[options]="generationItems"-->
                                 <!--(mainOption)="onGenerateSelectedItem(null)">-->
      <!--</gen-common-options-button>-->
    <!--</div>-->

    <div *ngIf='!completed && showAddendumReportActions' class="actions-section">
      <gen-button class="btn btn-primary Marginbox__t-small" style="padding: 0"
                  [text]="releaseButtonText"
                  (click)="onReleaseReport()"></gen-button>
    </div>

    <div *ngIf='!completed && enableGenerateAndDownloadButton' class="actions-section">
      <gen-button class="btn btn-primary Marginbox__t-small" style="padding: 0"
                  [text]="generateAndDownloadButtonText"
                  (click)="onAddAndDownloadReport()"
                  [disabled]="!editingIsPermitted"></gen-button>
    </div>

    <!-- This part is related to final/addendum reports -->
    <div *ngIf='completed && showAddendumReportActions' class="actions-section">
      <gen-button class="btn btn-primary Marginbox__t-small" style="padding: 0"
                  [text]="releaseButtonText"
                  (click)="onReleaseReport()"></gen-button>
    </div>

    <div *ngIf='completed && showPrintButton' class="actions-section">
      <gen-common-options-button class="actions-options-button"
                                 [buttonText]="'Print all documents'"
                                 [options]="printItems"
                                 (mainOption)="onPrintSelectedItem(null)">
      </gen-common-options-button>
    </div>
  </div>
</div>
